<template>
  <div class="heading_container">
    <div class="text">
      <h1>{{ title }}</h1>
      <h2>{{ subtitle }}</h2>
    </div>
    <i class="fas fa-chevron-down"></i>
  </div>
</template>

<script src="./MainHeading.js"></script>
<style src="./MainHeading.scss" lang="scss" scoped></style>